/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { ErrorPayload } from '@src/types';
import { IntegrationApp } from '@src/types/integrations';

type RequestStatus = 'idle' | 'loading' | 'success' | 'failure';
type RequestType = 'fetching' | 'updating' | 'patching';

export type IntegrationAppsState = {
  apps: IntegrationApp[];
  requestState: {
    type: RequestType;
    status: RequestStatus;
    error?: ErrorPayload;
  };
};

const initialState: IntegrationAppsState = {
  apps: [],
  requestState: {
    type: 'fetching',
    status: 'idle',
  },
};

const integrationsSlice = createSlice({
  name: 'integrationsApps',
  initialState,
  reducers: {
    fetchIntegrationApps(state) {
      state.requestState.type = 'fetching';
      state.requestState.status = 'loading';
    },

    patchIntegrationAppActive(
      state,
      _: PayloadAction<{ appId: string; active: boolean }>
    ) {
      state.requestState.type = 'patching';
      state.requestState.status = 'loading';
    },

    setIntegrationApps(state, action: PayloadAction<IntegrationApp[]>) {
      state.apps = action.payload;
      state.requestState.status = 'success';
    },

    setIntegrationApp(
      state,
      {
        payload,
      }: PayloadAction<{ appId: string; app: Partial<IntegrationApp> }>
    ) {
      const appIndex = state.apps.findIndex(({ id }) => id === payload.appId);
      if (appIndex !== -1) {
        state.apps[appIndex] = {
          ...state.apps[appIndex],
          ...payload.app,
        };
        state.requestState.status = 'success';
      }
    },

    setIntegrationAppsRequest(
      state,
      action: PayloadAction<Omit<IntegrationAppsState['requestState'], 'type'>>
    ) {
      state.requestState = { ...state.requestState, ...action.payload };
    },
  },
});

export default integrationsSlice.reducer;

export const integrationApps = integrationsSlice.actions;
